import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchOwnPastAppointments,
  fetchOwnUpcomingAppointments,
} from '@/api/appointments/appointmentsApi';
import type { OwnerAppointment } from '@/api/appointments/appointmentsApi.types';
import { OWN_UPCOMING_APPOINTMENTS_QUERY_KEY } from '@/constants/queryKeys';

export function useOwnUpcomingAppointmentsQuery(
  isEnabled: boolean
): UseQueryResult<OwnerAppointment[], Error> {
  return useQuery({
    queryKey: OWN_UPCOMING_APPOINTMENTS_QUERY_KEY,
    queryFn: fetchOwnUpcomingAppointments,
    enabled: isEnabled,
  });
}

export function useOwnPastAppointmentsQuery(
  isEnabled: boolean
): UseQueryResult<OwnerAppointment[], Error> {
  return useQuery({
    queryKey: [...OWN_UPCOMING_APPOINTMENTS_QUERY_KEY, 'past'],
    queryFn: fetchOwnPastAppointments,
    enabled: isEnabled,
  });
}
